<template>
  <VListGroup
    v-if="appAllowAccess(authenticated, roles, permissions) && ($attrs.debug ? isAppDebugMode : true)"
    :prepend-icon="icon"
    :title="title"
    no-action
  >
    <template #activator>
      <VListItemContent>
        <VListItemTitle>
          {{ title }}
          <div
            v-if="custom"
            v-html="custom"
          />
        </VListItemTitle>
      </VListItemContent>
    </template>

    <NavItem
      v-for="item in child"
      :key="item.title + Date.now()"
      v-bind="item"
    />
  </VListGroup>
</template>

<script>
import NavItem from '@/components/layouts/Sidebar/NavItem.vue'

export default {
  components: {
    NavItem
  },
  props: {
    child: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-circle'
    },
    color: {
      type: String,
      default: 'primary'
    },
    custom: {
      type: String,
      default: ''
    },
    authenticated: {
      type: Boolean,
      default: false
    },
    roles: {
      type: Array,
      default: () => []
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
  }
}
</script>
